import "./styles.scss";

import React, { useState, forwardRef, useRef } from "react";
import { Link } from "gatsby";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";

import Social from "components/Social";
import SiteLogo from "components/SiteLogo";
import Nav from "../Nav";
import Contact from "../../../Info";

import { getColorVariant } from "utils";

import { headerData } from "data/header";

const Static = forwardRef(({ page }, ref) => {
  const innerRef = useRef(null);

  const [dropdown, setDropdown] = useState(null);
  const [dropdownHeight, setDropdownHeight] = useState(0);
  const [isSocialOpen, setIsSocialOpen] = useState(false);

  const hideDropdown = () => setDropdown(null);

  const handleDropdownHeight = () => {
    const inner = innerRef.current;

    if (inner) setDropdownHeight(inner.clientHeight);
  };

  return (
    <header className={clsx("header-desktop-static")} ref={ref}>
      <div className="container">
        <div className="header-desktop-static__row">
          <div
            className="header-desktop-static__actions"
            role="presentation"
            onMouseLeave={hideDropdown}
          >
            <div className="header-desktop-static__actions-buttons">
              <button
                className="has-arrow"
                type="button"
                onMouseEnter={() => setDropdown("location")}
              >
                {headerData.location.label}
                <span />
              </button>
              <button
                className="has-arrow"
                type="button"
                onMouseEnter={() => setDropdown("call")}
              >
                {headerData.call.label}
                <span />
              </button>
              <Link to={headerData.question.url} onMouseEnter={hideDropdown}>
                {headerData.question.label}
              </Link>
              <Link to={headerData.reservation.url} onMouseEnter={hideDropdown}>
                {headerData.reservation.label}
              </Link>
            </div>
            <AnimatePresence>
              {dropdown && (
                <motion.div
                  className="header-desktop-static__actions-dropdown"
                  style={{ "--dropdown-height": dropdownHeight + "px" }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ type: "tween", duration: 0.3 }}
                >
                  <AnimatePresence exitBeforeEnter>
                    <motion.div
                      key={dropdown}
                      ref={innerRef}
                      className="header-desktop-static__actions-dropdown-inner"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ type: "tween", duration: 0.3 }}
                      onAnimationStart={(definition) => {
                        if (definition.opacity === 1) handleDropdownHeight();
                      }}
                    >
                      {dropdown === "location" &&
                        headerData.location.data.map((item, index) => (
                          <div key={index}>
                            <Contact
                              title={item.name}
                              variant={getColorVariant(index + 1)}
                            >
                              <div>
                                {item.hours.map((hour, index) => (
                                  <p key={index}>{hour}</p>
                                ))}
                              </div>
                              <div>
                                <p>{item.address}</p>
                              </div>
                            </Contact>
                          </div>
                        ))}
                      {dropdown === "call" &&
                        headerData.call.data.map((item, index) => (
                          <div key={index}>
                            <Contact
                              title={item.name}
                              variant={getColorVariant(index + 1)}
                            >
                              <div>
                                <ul>
                                  {item.phones.map((phone, index) => (
                                    <li key={index}>
                                      <a
                                        href={`tel:+48${phone.replaceAll(
                                          " ",
                                          ""
                                        )}`}
                                      >
                                        {phone}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </Contact>
                          </div>
                        ))}
                    </motion.div>
                  </AnimatePresence>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div
            className={clsx(
              "header-desktop-static__social",
              isSocialOpen && "header-desktop-static__social--open"
            )}
          >
            <button
              className="header-desktop-static__social-toggle"
              type="button"
              onClick={() => setIsSocialOpen((prevOpen) => !prevOpen)}
            >
              Social media
            </button>
            <div className="header-desktop-static__social-dropdown">
              <Social isLight />
            </div>
          </div>
        </div>
        <div className="header-desktop-static__row">
          <div className="header-desktop-static__logo">
            <SiteLogo isLight />
          </div>
          <Nav isBorderless />
        </div>
      </div>
    </header>
  );
});

export default Static;
